<template>
    <a-checkbox-group :options="options" :value="modelValue" :disabled="disabled" @change="onChange">
        <slot></slot>
    </a-checkbox-group>
</template>

<script>
export default {
    props: ['disabled', 'options', 'modelValue'],
    methods: {
        onChange(checkedValues) {
            this.$emit('update-roles', checkedValues);
        },
    },
};
</script>
